import React, { useState, useEffect } from 'react'
import moment from 'moment'
import ReactGA from 'react-ga'
import { isEmpty } from 'lodash'
import { useRequest } from '../utils/hooks'
import DialogPhoto from './DialogPhoto'
import PhotosListComponent from '../components/PhotosListComponent'
// import { photos } from '../constants/photos'

const PhotosList = ({
  searchParams,
  photosState,
  setPhotosState,
  pagination,
  setPagination,
  pageProps,
}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const [dialogPhoto, setDialogPhoto] = useState({ isOpen: false, data: null })

  const [photos, statusRequestPhotos, fetchPhotos] = useRequest(
    [],
    {
      url: `midias_app/listar`,
      method: 'get',
      params: {
        id_categoria_envio: pageProps.idCategoriaEnvio,
        currentPage: !isEmpty(searchParams) ? 0 : pagination.currentPage,
        pageSize: !isEmpty(searchParams) ? 300 : pagination.pageSize,
        data_inicio: searchParams.data_inicio
          ? moment(searchParams.data_inicio).format('YYYY-MM-DD 00:00:00')
          : '',
        data_fim: searchParams.data_fim
          ? moment(searchParams.data_fim).format('YYYY-MM-DD 23:59:59')
          : '',
        telespectador: searchParams.telespectador
          ? searchParams.telespectador
          : '',
      },
    },
    null,
    {
      onComplete: data => {
        if (!isEmpty(searchParams)) {
          setPhotosState(data.rows)
          setPagination({ ...pagination, currentPage: 0 })
        } else {
          setPagination({
            ...pagination,
            currentPage: pagination.currentPage + 1,
          })
          setPhotosState([...photosState, ...data.rows])
        }
      },
    }
  )

  const [, , fetchPhoto] = useRequest(
    [],
    {
      url: `midias_app/visualizar`,
      method: 'get',
      params: {
        id: urlParams.get('foto'),
      },
    },
    null,
    {
      onComplete: data => {
        if (data.arquivo.id) {
          setDialogPhoto({
            isOpen: true,
            data: data.arquivo,
          })

          ReactGA.event({
            category: pageProps.title,
            action: 'Opened shared photo',
          })
        }
      },
    }
  )

  useEffect(() => {
    fetchPhotos()

    if (urlParams.get('foto')) {
      fetchPhoto()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (searchParams) {
      fetchPhotos()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  return (
    <>
      <PhotosListComponent
        setDialogPhoto={setDialogPhoto}
        photosState={photosState || []}
        photos={photos}
        statusRequestPhotos={statusRequestPhotos}
        fetchPhotos={fetchPhotos}
        searchParams={searchParams}
        pageProps={pageProps}
      />

      <DialogPhoto
        dialog={dialogPhoto}
        setDialog={setDialogPhoto}
        pageProps={pageProps}
      />
    </>
  )
}

export default PhotosList
